export const MinnowActionTypes = {
  GET_MINNOW_DATA: 'GET_MINNOW_DATA',
  SERVICE_BRAND_NEWS: 'SERVICE_BRAND_NEWS',
  SERVICE_BRAND_TRAINING: 'SERVICE_BRAND_TRAINING',
  SERVICE_BRAND_EVENTS: 'SERVICE_BRAND_EVENTS',
};
